import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export function DefaultLoadingComponent({
  pastDelay
}) {
  if (!pastDelay) {
    return null;
  }
  return /*#__PURE__*/_jsx(UILoadingSpinner, {
    minHeight: 400,
    grow: true,
    layout: "centered",
    size: "medium"
  });
}